import { useQuery } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useAsset = (id) => {
  const { loggedIn, securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()

  const getAsset = async (id) => {
    const fetchFn = loggedIn ? securedFetch : fetch
    const url = encodeURI(
      loggedIn
        ? `${env.apiUrl}/userAssets/${id}`
        : `${env.publicApiUrl}/assets/${id}`
    )
    const response = await fetchFn(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['assets', id],
    queryFn: () => getAsset(id),
    enabled: !!id,
    refetchOnWindowFocus: false
  })

  query.isError && handleError(query.error, 'Error getting asset')

  return {
    asset: query.data
  }
}

export { useAsset }
